import { Section, SectionHeading } from "@/components/common/Section";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { faqs } from "@/data/content";
import { waLink } from "@/config/site";

export function Faqs() {
  return (
    <Section id="faqs" bg="mist">
      <div className="grid gap-12 lg:grid-cols-3 lg:gap-16">
        <div className="lg:col-span-1">
          <SectionHeading
            eyebrow="FAQs"
            title="Answers to common questions"
            subtitle="Still have a question? Reach out on WhatsApp and we'll respond quickly."
          />
          <a
            href={waLink("Hi BNZ Solutions, I have a question about your services.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="faq-whatsapp"
            className="mt-6 inline-flex items-center bg-navy px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-navy-light"
          >
            Ask on WhatsApp
          </a>
        </div>
        <div className="lg:col-span-2">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-black/10">
                <AccordionTrigger className="text-left font-heading text-lg text-navy hover:text-gold-dark hover:no-underline py-5" data-testid={`faq-trigger-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base leading-relaxed text-charcoal/75 pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </Section>
  );
}
